<template>
  <div
    class="welcome-container"
    :class="{ 'welcome-container-with-box': isShowBgBox }"
  >
    <div class="logo-container">
      <div
        class="logo-inner"
        ref="logoInner"
        :style="{
          position: logoPosition.position,
          left: `${logoPosition.left}px`,
          top: `${logoPosition.top}px`,
          transform: `scale(${logoPosition.scale})`,
        }"
      >
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/welcome/logo-1.png"
          class="ting"
          alt=""
          :style="{
            transform: `translateY(${tingTrans.y}vh)`,
            opacity: `${tingTrans.op}`,
          }"
        />
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/welcome/logo-2.png"
          class="jian"
          alt=""
          key=""
          :style="{
            transform: `translateY(${jianTrans.y}vh)`,
            opacity: `${jianTrans.op}`,
          }"
        />
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/welcome/logo-3.png"
          class="xiaokang"
          alt=""
          :style="{
            transform: `translateY(${xiaokangTrans.y}vh)`,
            opacity: `${xiaokangTrans.op}`,
          }"
        />
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/welcome/logo-4.png"
          class="bird"
          alt=""
          :style="{
            transform: `translateY(${birdTrans.y}vh) translateX(${birdTrans.x}vh)`,
            opacity: `${birdTrans.op}`,
          }"
        />
      </div>
    </div>
    <div class="content-container">
      <div
        class="content-inner"
        :style="{
          width: `${contentInnerSize.width}px`,
          height: `${contentInnerSize.height}px`,
        }"
      >
        <img
          src="../assets/welcome/car.png"
          alt=""
          class="car-img"
          :style="{
            left: `${carPosition.left}px`,
            opacity: `${carPosition.op}`,
          }"
          @click="next"
          v-if="isShowBgBox"
        />

        <img
          src="../new-assets/chickred.png"
          alt=""
          class="tip-img"
          :class="{ carImgAni: isCarMoved }"
          :style="{
            left: `${carPosition.left + 20}px`,
            opacity: `${carPosition.op}`,
          }"
          @click="next"
          v-if="isShowBgBox && isShowCarTip"
        />

        <div class="left">
          <div class="logo-box-before" ref="logoBox"></div>
          <div
            class="logo-box"
            :style="{ height: `${logoContainerHeight}px` }"
          ></div>
          <div class="text-box" ref="textBox" v-if="isShowBgBox">
            <img
              src="../new-assets/updown.png"
              class="tip-icon"
              alt=""
              v-if="isShowBoxTip"
            />
            <p>
              江苏苏州，小康宏图的起笔处！1983年，邓小平来到这里，调研小康目标的可行性。
            </p>
            <p>
              2020年，决胜全面建成小康社会取得决定性成就。“听·见小康”大型融媒体行动记者开着“小康幸福车”、带着“小康照相馆”和“小康签名长卷”，与城乡居民面对面交流，记录下许多鲜活的小康故事、生动的小康笑脸和真切的小康心愿。
            </p>
            <p>
              听，时代之声；见，小康画卷。1年，18地，从江苏全省到其对口支援帮扶的五省区……一段特殊的“听·见小康”之旅，邀你来参加！途中还会有惊喜哦！
            </p>
          </div>
        </div>
        <div class="right" ref="right">
          <canvas id="canvas" ref="canvas"></canvas>
          <div class="map" v-if="isShowBgBox">
            <div
              class="area"
              v-for="(area, index) in areas"
              :key="index"
              :style="{ left: `${area.x}%`, bottom: `${area.y}%` }"
              @click="showLabel(index)"
            >
              {{ index + 1 }}
            </div>
            <template v-for="(area, index) in areas">
              <div
                :key="index + 100"
                v-if="area.isShowLabel"
                class="label"
                :style="{ left: `${area.x}%`, bottom: `${area.y}%` }"
              >
                {{ area.label }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const TWEEN = require("@tweenjs/tween.js");

const ANI_TIME = {
  SHOT: 200,
  FONT_SHOW: 800,
  BIRD: 1200,
  FONT_SHOW_WAIT: 1000,
  LOGO_MOVE: 500,

  // SHOT: 0,
  // FONT_SHOW: 0,
  // BIRD: 0,
  // FONT_SHOW_WAIT: 0,
  // LOGO_MOVE: 0,
};

export default {
  props: {
    next: Function,
  },
  data() {
    return {
      isAnimate: true,
      contentInnerSize: {
        width: 100,
        height: 100,
      },
      logoPosition: {
        position: "relative",
        left: 0,
        top: 0,
        scale: 1,
      },
      tingTrans: { x: 0, y: -50, op: 0 },
      jianTrans: { x: 0, y: -50, op: 0 },
      xiaokangTrans: { x: 0, y: -50, op: 0 },
      birdTrans: { x: 30, y: -50, op: 0 },
      isShowBgBox: false,

      carPosition: {
        left: 0,
        op: 0,
      },
      isCarMoved: false,
      isShowCarTip: false,

      areas: [],
      areaStroge: [
        {
          label: "苏州",
          x: 53,
          y: 6,
          isShowLabel: true,
        },
        {
          label: "无锡",
          x: 47,
          y: 16,
          isShowLabel: true,
        },
        {
          label: "常州",
          x: 38,
          y: 23,
          isShowLabel: true,
        },
        {
          label: "镇江",
          x: 33,
          y: 33,
          isShowLabel: true,
        },
        {
          label: "南京",
          x: 23,
          y: 34,
          isShowLabel: true,
        },
        {
          label: "扬州",
          x: 35,
          y: 40,
          isShowLabel: true,
        },
        {
          label: "泰州",
          x: 44,
          y: 36,
          isShowLabel: true,
        },
        {
          label: "南通",
          x: 56,
          y: 33,
          isShowLabel: true,
        },
        {
          label: "盐城",
          x: 51,
          y: 50,
          isShowLabel: true,
        },
        {
          label: "淮安",
          x: 34,
          y: 56,
          isShowLabel: true,
        },
        {
          label: "宿迁",
          x: 22,
          y: 70,
          isShowLabel: true,
        },
        {
          label: "徐州",
          x: 3,
          y: 83,
          isShowLabel: true,
        },
        {
          label: "连云港",
          x: 43,
          y: 86,
          isShowLabel: true,
          break: true,
        },
        {
          label: "商洛",
          x: 59,
          y: 90,
          isShowLabel: true,
        },
        {
          label: "西宁",
          x: 80,
          y: 80,
          isShowLabel: true,
        },
        {
          label: "伊犁",
          x: 74,
          y: 62,
          isShowLabel: true,
        },
        {
          label: "拉萨",
          x: 81,
          y: 36,
          isShowLabel: true,
        },
        {
          label: "铜仁",
          x: 95,
          y: 24,
          isShowLabel: true,
        },
      ],
      isHideV: false,

      isShowBoxTip: true,

      fromRect: null, //onResize
      logoContainerHeight: 0,
    };
  },

  async mounted() {
    this.animateUpdate();
    this.setContentSize();
    await this.showFontAndBird();
    await this.showBox();
    window.addEventListener("resize", this.onResize);
    this.autoScroll();
  },
  beforeDestroy() {
    this.isAnimate = false;
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    onResize() {
      this.setContentSize();
      this.$nextTick(() => this.showBox(true));
    },

    setContentSize() {
      let isFat = window.innerWidth / window.innerHeight > 1600 / 1000;
      if (isFat) {
        this.contentInnerSize.width = window.innerWidth * 0.78; // magic number
        this.contentInnerSize.height = this.contentInnerSize.width * 0.54; // magic number
      } else {
        // 更窄
        this.contentInnerSize.height = window.innerHeight * 0.67; // magic number
        this.contentInnerSize.width = this.contentInnerSize.height * 1.85; // magic number
      }
      this.logoContainerHeight = this.contentInnerSize.width * 0.5 * 0.8 * 0.45;
    },

    async showFontAndBird() {
      await this._oneAnimate(ANI_TIME.FONT_SHOW, this.tingTrans, {
        x: 0,
        y: 0,
        op: 1,
      });
      await this.awaitDelay();
      await this._oneAnimate(ANI_TIME.FONT_SHOW, this.jianTrans, {
        x: 0,
        y: 0,
        op: 1,
      });
      await this.awaitDelay();
      await this._oneAnimate(ANI_TIME.FONT_SHOW, this.xiaokangTrans, {
        x: 0,
        y: 0,
        op: 1,
      });
      await this.awaitDelay();
      await this._oneAnimate(
        ANI_TIME.BIRD,
        this.birdTrans,
        {
          x: 0,
          y: 0,
          op: 1,
        },
        true
      );
      await this.awaitDelay(ANI_TIME.FONT_SHOW_WAIT);
    },

    async showBox(immediately = false) {
      this.isShowBgBox = true;
      setTimeout(() => {
        this.isShowBoxTip = false;
      }, 3000);
      let toRect = this.$refs.logoBox.getBoundingClientRect();
      let fromRect =
        this.fromRect || this.$refs.logoInner.getBoundingClientRect();
      this.fromRect = fromRect;

      let scaleNumber = toRect.width / fromRect.width;
      this.logoPosition.position = "absolute";
      this.logoPosition.left = fromRect.left;
      this.logoPosition.top = fromRect.top;

      this.$nextTick(() => {
        this._oneAnimate(
          immediately ? 0 : ANI_TIME.LOGO_MOVE,
          this.logoPosition,
          {
            left: toRect.left,
            top: toRect.top,
            scale: scaleNumber,
          },
          true
        );
      });
    },

    async _oneAnimate(during, from, to, isLiner = false) {
      return new Promise((resolve) => {
        new TWEEN.Tween(from)
          .to(to, during)
          .onComplete(resolve)
          .start()
          .easing(isLiner ? TWEEN.Easing.Linear.None : TWEEN.Easing.Back.InOut);
      });
    },

    animateUpdate() {
      TWEEN.update();
      if (this.isAnimate) {
        requestAnimationFrame(this.animateUpdate);
      }
    },

    async awaitDelay(delay = ANI_TIME.SHOT) {
      return new Promise((resolve) => {
        setTimeout(resolve, delay);
      });
    },

    async autoDraw() {
      for (let i = 0; i <= this.areaStroge.length - 1; i++) {
        this.areas.push(this.areaStroge[i]);
        this.drawMapLine();
        setTimeout(() => {
          this.areas[i].isShowLabel = false;
        }, 2000);
        await this.awaitDelay(1000);
      }
    },

    drawMapLine() {
      // 画线
      let canvasDom = document.getElementById("canvas");

      let canvas = this.$refs.canvas;
      if (!canvas) return;
      canvas.width = canvasDom?.offsetWidth;
      canvas.height = canvasDom?.offsetHeight;
      let context = canvas.getContext("2d");
      if (!context) return;

      context.strokeStyle = "#e5827f";
      context.lineWidth = 2;

      let points = this.areas.map((area) => {
        let x = (canvas.width * area.x) / 100;
        let y = (canvas.height * (100 - area.y)) / 100;
        let isBreak = area.break;

        return [x, y, isBreak ? 1 : 0];
      });

      context.beginPath();
      context.setLineDash([5, 5]);

      context.moveTo(points[0][0], points[0][1]);
      points.forEach((p, i) => {
        if (!context) return;
        context.lineTo(p[0], p[1]);
        if (p[2]) {
          context.stroke();
          if (points[i + 1]) {
            context.moveTo(points[i + 1][0], points[i + 1][1]);
          }
        }
      });
      context.stroke();
    },

    showLabel(i) {
      this.areas[i].isShowLabel = true;
      setTimeout(() => {
        this.areas[i].isShowLabel = false;
      }, 2000);
    },

    async autoScroll() {
      this.isHideV = true;
      // move the car
      await this._oneAnimate(
        ANI_TIME.LOGO_MOVE,
        this.carPosition,
        {
          left: window.innerWidth * 0.35,
          op: 10,
        },
        true
      );
      this.isCarMoved = true;
      setTimeout(() => {
        this.isShowCarTip = true;
      }, 2000);
      // 递归的await不知道咋搞
      await this.awaitDelay(1000);

      this.$nextTick(this.autoDraw);
    },
  },
};
</script>

<style lang="less" scoped>
.welcome-container {
  width: 100vw;
  height: 100vh;
  background-image: url("https://jcdn.xhby.net/project/xiaokang/assets/welcome/bg0.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  overflow: hidden;

  .village {
    display: none;
  }

  .logo-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .logo-inner {
      padding-top: 1px;
      transform-origin: 20px 20px;

      .ting {
        width: 25.67vh;
        opacity: 1;
      }

      .jian {
        opacity: 0;
        width: 38.04vh;
        position: relative;
        top: -8vh;
        margin-left: -13vh;
      }
      .xiaokang {
        opacity: 0;
        width: 26.88vh;
        position: relative;
        margin-left: -8vh;
        top: -13vh;
      }
      .bird {
        width: 11.52vh;
        position: relative;
        top: -30vh;
        opacity: 0;
      }
    }
  }

  .content-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;

    .content-inner {
      display: flex;
      position: relative;

      .car-img {
        position: absolute;
        bottom: 0;
        height: 14vh;
        transition: all 500;
        z-index: 10;
        display: block;
        cursor: pointer;
      }

      .tip-img {
        position: absolute;
        bottom: 10px;
        height: 10vh;
        transition: all 500;
        z-index: 10;
        display: block;
      }

      .carImgAni {
        animation: shine 1.8s infinite linear;
      }

      .left {
        width: 50%;
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;

        .logo-box-before {
          width: 80%;
          height: 0;
        }

        .logo-box {
          width: 80%;
        }

        .text-box {
          flex: 1;
          overflow: auto;
          font-size: 1.5vw;
          line-height: 2vw;
          padding: 10px;
          opacity: 0;
          animation: slowShow forwards 1s;
          animation-delay: 1s;
          text-indent: 2em;
          color: #9c3334;
          padding-bottom: 60px;
          font-family: FangSong;
          text-align: justify;
          position: relative;

          .tip-icon {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 10vh;
            animation: ud 2s infinite linear;
          }
        }
      }

      .right {
        flex: 1;
        margin-left: 10px;
        position: relative;

        #canvas {
          width: 100%;
          height: 70%;
          z-index: 10;
          position: absolute;
          left: 0;
          top: 0;
        }

        .map {
          width: 100%;
          height: 70%;
          position: relative;
          z-index: 20;
          opacity: 0;
          animation: slowShow forwards 1s;

          .area {
            position: absolute;
            width: 30px;
            height: 30px;
            background: #fef0f0;
            color: #8dc3b2;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transform: translateX(-50%) translateY(50%);
            z-index: 10;
            font-size: 16px;
            cursor: pointer;
          }

          .label {
            position: absolute;
            background: #fdb4ae;
            white-space: nowrap;
            overflow: hidden;
            border-radius: 12px;
            padding: 4px 10px;
            color: white;
            z-index: 100;
            transform: translateX(-140%) translateY(50%);
            font-size: 16px;
            animation: slowShow 0.3s;
          }
        }
      }
    }
  }
}

.welcome-container-with-box {
  background-image: url("https://jcdn.xhby.net/project/xiaokang/assets/welcome/bg.jpg");

  .village {
    display: block;
    position: fixed;
    right: 3vw;
    bottom: -4vw;
    width: 40vw;
    opacity: 1;

    @media (max-device-height: 760px) {
      bottom: 1vw;
    }
  }

  .village-op {
    opacity: 0.5;
    transition: all 0.5s;
  }
}

@keyframes slowShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes shine {
  from {
    transform: scale(1);
  }

  50% {
    transform: scale(1.25);
  }

  to {
    transform: scale(1);
  }
}

@keyframes ud {
  from {
    top: 50%;
  }

  50% {
    top: 40%;
  }

  to {
    top: 50%;
  }
}
</style>